import { render } from "./UpdateDashboard.vue?vue&type=template&id=5886a5f3&scoped=true"
import script from "./UpdateDashboard.vue?vue&type=script&lang=js"
export * from "./UpdateDashboard.vue?vue&type=script&lang=js"

import "./UpdateDashboard.vue?vue&type=style&index=0&id=5886a5f3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5886a5f3"]])

export default __exports__